const e = {
  "pipeline-lane-row": "pipeline-lane-row",
  "pipeline-lane-row--tight-gap": "pipeline-lane-row--tight-gap"
};
export {
  e as default
};
